import MarkdownRenderer from "../components/MarkdownRenderer";

const TodoVanilla = () => {
  return (
    <div>
      <MarkdownRenderer filePath="/posts/TodoVanilla.md" />
    </div>
  );
};

export default TodoVanilla;
